import { Injectable } from '@angular/core';
import { SearchItem } from '../../../../models/search-item';
import { Aggregate } from '../../../../models/aggregate';

import { createAction, props, Store } from '@ngrx/store';
import {IFilterAction} from '../../../filter/filter-action-interface';
import { ProcessStateEnum, WkfSupervisionFilterDatas } from '../reducer/wkf-supervision-filter.reducer';

export class WkfSupervisionFilterActionConstantAction {
  static readonly ADD_FILTER_ITEMS_START = '[FilterWkfSupervision].ADD_FILTER_ITEMS_START';
  static readonly ADD_FILTER_ITEMS_SUCCEEDED = '[FilterWkfSupervision].ADD_FILTER_ITEMS_SUCCEEDED';
  static readonly ADD_FILTER_ITEMS_FAILED = '[FilterWkfSupervision].ADD_FILTER_ITEMS_FAILED';

  static readonly UPDATE_FILTER_ITEMS_START = '[FilterWkfSupervision].UPDATE_FILTER_ITEMS_START';
  static readonly UPDATE_FILTER_ITEMS_SUCCEEDED = '[FilterWkfSupervision].UPDATE_FILTER_ITEMS_SUCCEEDED';
  static readonly UPDATE_FILTER_ITEMS_FAILED = '[FilterWkfSupervision].UPDATE_FILTER_ITEMS_FAILED';

  static readonly REMOVE_FILTER_ITEM_STARTED = '[FilterWkfSupervision].REMOVE_FILTER_ITEM_STARTED';
  static readonly REMOVE_FILTER_ITEM_SUCCEEDED = '[FilterWkfSupervision].REMOVE_FILTER_ITEM_SUCCEEDED';
  static readonly REMOVE_FILTER_ITEM_FAILED = '[FilterWkfSupervision].REMOVE_FILTER_ITEM_FAILED';

  static readonly REMOVE_ALL_FILTER_ITEMS_SUCCEEDED = 'REMOVE_ALL_FILTER_ITEMS_SUCCEEDED';
  static readonly REMOVE_FILTERS_AND_KEEP_LAST_AGG_SUCCEEDED = 'REMOVE_FILTERS_AND_KEEP_LAST_AGG_SUCCEEDED';

  static readonly UPDATE_PROCESS_STATE_FILTER_SUCCEEDED = '[FilterWkfSupervision].UPDATE_PROCESS_STATE_FILTER_SUCCEEDED '

}

export const addFilterItemsStartAction = createAction(WkfSupervisionFilterActionConstantAction.ADD_FILTER_ITEMS_START);
export const addFilterItemsSucceededAction = createAction(WkfSupervisionFilterActionConstantAction.ADD_FILTER_ITEMS_SUCCEEDED, props< {payload : { filterItems : SearchItem[], lastAgg: Aggregate }}>());
export const addFilterItemsFailedAction = createAction(WkfSupervisionFilterActionConstantAction.ADD_FILTER_ITEMS_FAILED, props<{error: Error}>());

export const updateFilterItemsStartAction= createAction(WkfSupervisionFilterActionConstantAction. UPDATE_FILTER_ITEMS_START);
export const updateFilterItemsSucceededAction = createAction(WkfSupervisionFilterActionConstantAction.UPDATE_FILTER_ITEMS_SUCCEEDED, props<{payload :WkfSupervisionFilterDatas}>());
export const updateFilterItemsFailedAction = createAction(WkfSupervisionFilterActionConstantAction.UPDATE_FILTER_ITEMS_FAILED, props<{error: Error}>());

export const removeFilterItemStartedAction = createAction(WkfSupervisionFilterActionConstantAction.REMOVE_FILTER_ITEM_STARTED);
export const removeFilterItemSucceededAction = createAction(WkfSupervisionFilterActionConstantAction.REMOVE_FILTER_ITEM_SUCCEEDED, props<{payload :WkfSupervisionFilterDatas} >() );
export const removeFilterItemFailedAction = createAction(WkfSupervisionFilterActionConstantAction.REMOVE_FILTER_ITEM_FAILED, props<{error: Error}>());
export const removeAllFilterItemsSucceededAction = createAction(WkfSupervisionFilterActionConstantAction.REMOVE_ALL_FILTER_ITEMS_SUCCEEDED);
export const removeFiltersAndKeepLastAggSucceededAction = createAction(WkfSupervisionFilterActionConstantAction.REMOVE_FILTERS_AND_KEEP_LAST_AGG_SUCCEEDED);


export const updateProcessStateFilterSucceedAction = createAction(WkfSupervisionFilterActionConstantAction.UPDATE_PROCESS_STATE_FILTER_SUCCEEDED, props<{payload : ProcessStateEnum}>());

@Injectable({
  providedIn: 'root'
})
export class WkfSupervisionFilterAction implements IFilterAction {

  constructor( private localStore: Store ) {
  }

  public addFilterStarted(): void {
    this.localStore.dispatch( addFilterItemsStartAction());
  }

  public addFilterSucceeded(filterItem: SearchItem, agg: Aggregate): void {
    const payload: { filterItems : SearchItem[], lastAgg: Aggregate }  = {
      filterItems: [filterItem],
      lastAgg: agg
    };

    this.localStore.dispatch(addFilterItemsSucceededAction( {payload} ));

  }

  public addFilterFailed(error: any) {
    this.localStore.dispatch( addFilterItemsFailedAction( {error}) );
  }

  public removeFilterStarted(): void {
    this.localStore.dispatch( removeFilterItemStartedAction());
  }

  public removeFilterSucceeded(filterItem: SearchItem) {
    const payload: WkfSupervisionFilterDatas  = {
      filterItems: [filterItem],
      lastAgg: null,
      processState:null
    }

    this.localStore.dispatch(removeFilterItemSucceededAction( {payload} ));

  }

  public removeFiltersAndKeepLastAgg(): void {
    this.localStore.dispatch(removeFiltersAndKeepLastAggSucceededAction());
  }

  public removeFilterFailed(error: any) {
    this.localStore.dispatch(removeFilterItemFailedAction({error}));

  }


  public removeAllFiltersSucceeded() {
    this.localStore.dispatch( removeAllFilterItemsSucceededAction());
  }


  updateFilterStarted() {
    this.localStore.dispatch( updateFilterItemsStartAction());
  }

  updateFilterSucceeded(filterItem: SearchItem, curAggregate: Aggregate) {
    const payload : WkfSupervisionFilterDatas ={
      filterItems: [filterItem],
      lastAgg: curAggregate,
      processState:null
    };

    this.localStore.dispatch(updateFilterItemsSucceededAction( {payload} ) );
  }

  updateFilterFailed(error: any) {
    this.localStore.dispatch( updateFilterItemsFailedAction(error));
  }

    updateProcessStateFilterSucceed( newProcessStateFilterValue: ProcessStateEnum ) {
        this.localStore.dispatch(updateProcessStateFilterSucceedAction({payload:newProcessStateFilterValue}));
    }
}
